import { FirestoreDataConverter } from 'firebase/firestore';
import { ExternalConnection } from 'shared/types/external-connections';

import { firebaseTimestampToDate } from './firebase-timestamp-to-date';

export const externalConnectionsConverter: FirestoreDataConverter<ExternalConnection> =
  {
    fromFirestore: (snapshot) => {
      const data = snapshot.data();
      return {
        ...data,
        updatedAt: firebaseTimestampToDate(data.updatedAt),
        createdAt: firebaseTimestampToDate(data.createdAt),
        lastUsedAt: firebaseTimestampToDate(data.lastUsedAt),
      } as ExternalConnection;
    },
    toFirestore: (externalConnection) => externalConnection,
  };
